import { DialogBox } from './DialogBox';
import { Toast } from './Toast';

export const Notifier = () => (
  <>
    <DialogBox />
    <Toast />
  </>
);
